export default __webpack_public_path__ + "static/media/AnilLogo.826c5ff1.webp";